import styled from 'styled-components'
import { Button } from 'antd'

// Animation constants
const ANIMATION_TIMINGS = {
  FADE_DURATION: '0.15s',
  COLLAPSE_DURATION: '0.3s',
};

const LAYOUT_CONSTANTS = {
  CASE_MAX_HEIGHT: '2000px',   // Arbitrary large value for collapse animation
  CASE_MARGIN: '12px',
};

export const CaseWrapper = styled.div`
  margin-bottom: ${LAYOUT_CONSTANTS.CASE_MARGIN};
  max-height: ${LAYOUT_CONSTANTS.CASE_MAX_HEIGHT};
  overflow: visible;
  transition: max-height ${ANIMATION_TIMINGS.COLLAPSE_DURATION} ease-in-out,
              margin-bottom ${ANIMATION_TIMINGS.COLLAPSE_DURATION} ease-in-out;
  
  &:first-child {
    margin-top: ${LAYOUT_CONSTANTS.CASE_MARGIN};
  }
  
  ${props => props.$iscollapsing === 'true' && `
    max-height: 0;
    margin-bottom: 0;
    overflow: hidden;
  `}
`

export const Case = styled.div`
  width: 100%;
  background: #ffffff;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  color: #2c3e50;
  border: 2px solid #e1e5e9;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  opacity: 1;
  transition: opacity ${ANIMATION_TIMINGS.FADE_DURATION} ease-in-out;
  
  ${props => props.$isfadingout === 'true' && `
    opacity: 0;
    pointer-events: none;
  `}
`
export const CaseHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 10px;
  background: ${props => props.$haserror === 'true' ? '#dc3545' : '#7BAD7E'};
  color: #ffffff;
  font-weight: 600;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  transition: background 0.3s ease;
`

export const PatientMetadataContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
`

export const CaseId = styled.div`
  font-size: 12px;
  font-family: system-ui, -apple-system, sans-serif;
  text-align: left;
  margin-top: -4px;
  margin-bottom: -4px;
`

export const PatientName = styled.div`
  font-size: 16px;
  font-weight: 600;
  text-align: left;
`

export const PatientDOB = styled.span`
  font-size: 11px;
  text-align: left;
`

export const IDVerified = styled.div`
  font-size: 12px;
  font-family: system-ui, -apple-system, sans-serif;
  text-align: left;
`

export const CaseMetadataContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
`

export const DateInfo = styled.div`
  font-size: 11px;
  text-align: right;
  margin-bottom: -4px;
`

export const StateInfo = styled.div`
  font-size: 15px;
  font-weight: 600;
  text-transform: capitalize;
  letter-spacing: 0.5px;
  margin-top: 2px;
  margin-left: auto;
`

export const ContentContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  padding: 20px;
  opacity: ${props => props.disabled ? 0.5 : 1};
`

export const SecondaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 40%;
  align-items: flex-start;
  gap: 30px;
`

export const PatientInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const PatientInfoSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 2px;
`

export const PatientInfoTitle = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: #2c3e50;
  text-align: left;
`

export const PatientInfoList = styled.div`
  display: flex;
  align-items: flex-start;
  text-transform: capitalize;
  flex-wrap: wrap;
  font-size: 12px;
  gap: 2px;
`

export const PrimaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  width: 60%;
  padding: 0 10px;
`

export const Eligibility = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const EligibilityTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  text-align: left;
`

export const EligibilityDescription = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #2c3e50;
  text-align: left;
`

export const PatientPresentation = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
`

export const Actions = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 4px;
`

export const ActionButton = styled(Button)`
  width: 100%;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #2c3e50;
  background-color: #ffffff;
  border: 1.5px solid #e1e5e9;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    border-radius: 50%;
    background: rgba(123, 173, 126, 0.1);
    transform: translate(-50%, -50%);
    transition: width 0.6s ease, height 0.6s ease;
  }

  &:hover {
    background-color: #7BAD7E;
    color: #ffffff;
    border-color: #7BAD7E;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(123, 173, 126, 0.3);
    
    &::before {
      width: 300px;
      height: 300px;
    }

    svg {
      transform: scale(1.1);
    }
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 6px rgba(123, 173, 126, 0.2);
    transition: all 0.1s ease;
  }

  &:focus,
  &:focus-visible {
    border-color: #7BAD7E !important;
    color: #7BAD7E !important;
    
    svg {
      color: #7BAD7E !important;
    }
  }

  svg {
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    font-size: 14px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
    
    &:hover {
      transform: none;
      background-color: #ffffff;
      color: #2c3e50;
      border-color: #e1e5e9;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    }
  }

  &.ant-btn-loading .ant-btn-loading-icon .anticon {
    padding: 0;
  }
`

export const VerticalDivider = styled.div`
  width: 1px;
  height: 170px;
  background-color: #000;
  align-self: center;
  margin: 0 20px;
`

export const ErrorMessage = styled.div`
  width: 100%;
  padding: 12px 20px;
  background-color: #f8d7da;
  border: 1px solid #f5c2c7;
  border-top: none;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
  color: #842029;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.4;
  display: flex;
  align-items: center;
  gap: 8px;
  pointer-events: auto;
  margin-top: -1px;
  
  .anticon {
    color: #dc3545;
    font-size: 16px;
    flex: 0 0 auto;
  }
  
  span {
    flex: 1 1 auto;
  }
`

export const ErrorDismissButton = styled.button`
  padding: 6px 16px;
  background-color: #dc3545;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
  flex-shrink: 0;
  pointer-events: auto;
  position: relative;
  z-index: 10;
  
  &:hover {
    background-color: #bb2d3b;
  }
  
  &:active {
    background-color: #a02532;
  }
`